import { useCallback } from "react"
import { EventBus } from "../../eventbus"
import { ZuAbschlag } from "../../models/rechnung/rechnungsebene/zuAbschlag"

export const useZuAbschlag = (zuAbschlaege: ZuAbschlag[], type: "rechnungZuschlaege" | "rechnungAbschlaege") => {
    const add = useCallback(() => {
        EventBus.instance.emit("changeProperty", type, [...zuAbschlaege, new ZuAbschlag()])
    }, [zuAbschlaege, type])

    const remove = useCallback(
        (idx: number) => {
            EventBus.instance.emit(
                "changeProperty",
                type,
                zuAbschlaege.filter((_, i) => i !== idx),
            )
        },
        [zuAbschlaege, type],
    )

    const onChange = useCallback(
        (idx: number) => {
            return (value: ZuAbschlag) =>
                EventBus.instance.emit(
                    "changeProperty",
                    type,
                    zuAbschlaege.map((a, index) => (idx === index ? value : a)),
                )
        },
        [zuAbschlaege, type],
    )

    return { add, remove, onChange }
}
